<!-- @format -->

<div class="modal-header" data-cy="info-modal">
  <h2 class="modal-title" translate>{{ values.title }}</h2>
  <button type="button" class="modal-close" (click)="modalInstance.close()" [attr.aria-label]="'ARIA_LABEL.CLOSE' | translate">
    <sis-icon icon="ring-close"></sis-icon>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12">
      @for (description of values.descriptions; track description) {
        <sis-markup-string-view [content]="description | translate"></sis-markup-string-view>
      }
      @if (values.list) {
        <sis-show-more-list
          [description]="values.list.description"
          [items]="values.list.items"
          [showingAllItemsText]="values.list.showingAllItemsText">
        </sis-show-more-list>
      }
    </div>
  </div>
</div>
